import React, { useEffect, useState } from 'react';
import { authFetch, API } from '../api';

// "Who is …?" — a shared tablet login (users.is_device) says which PERSON is doing the work, so the
// record names the person and the login stays beside it. One component for the calibration walk
// (was WhoIsWalking inside warehouse/CalibrateWalk.tsx) and the Inventory count (2026-10-06).
export interface Person { username: string; name: string; lang?: string }

export default function WhoIsWorking({ title, onPick, onCancel }: {
  title: string; onPick: (p: Person) => void; onCancel: () => void;
}) {
  const [people, setPeople] = useState<Person[]>([]);
  const [err, setErr] = useState('');
  useEffect(() => {
    authFetch(`${API}/pp/people`).then(r => r.json()).then(d => setPeople(d.people || [])).catch(() => setErr('Could not load the people'));
  }, []);
  return (
    <div className="p-6 max-w-xl">
      <h2 className="text-xl font-semibold text-white mb-4">{title}</h2>
      {err && <div className="text-red-400 text-sm mb-3">{err}</div>}
      <div className="grid grid-cols-2 gap-3 keep-cols">
        {people.map(p => (
          <button key={p.username} onClick={() => onPick(p)}
            className="rounded-xl bg-gray-800 hover:bg-blue-600 text-white text-lg py-4 px-3">{p.name}</button>
        ))}
      </div>
      <button onClick={onCancel} className="mt-5 text-gray-400 hover:text-white text-sm">Cancel</button>
    </div>
  );
}
